var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: 'dinProSemiBold';\r\n  src: url(" + escape(require("./D-DIN-PRO-600-SemiBold.otf")) + ");\r\n}\r\n@font-face {\r\n  font-family: 'dinProRegular';\r\n  src: url(" + escape(require("./D-DIN-PRO-400-Regular.otf")) + ");\r\n}\r\n\r\n.semiBold {\r\n  font-family: 'dinProSemiBold';\r\n}\r\n.regular {\r\n  font-family: 'dinProRegular';\r\n}\r\n.pingFang {\r\n  font-family: 'PingFang SC, PingFang SC';\r\n  font-weight: 500;\r\n}\r\n", ""]);

// exports
